<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Add Charges"
            bc1="App"
            bc2="Add Charges"
            bc3="Add"
            path="privilege-role-add"
          ></Breadcrumb>
        </div>
        <div
          class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
          <div class="form-group breadcrumb-right">
            <div class="dropdown">
              <button
                class="btn-icon btn btn-primary btn-round btn-sm dropdown-toggle"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <CommandIcon />
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                <a class="dropdown-item" href="app-todo.html"
                  ><i class="mr-1" data-feather="check-square"></i
                  ><span class="align-middle">Todo</span></a
                ><a class="dropdown-item" href="app-chat.html"
                  ><i class="mr-1" data-feather="message-square"></i
                  ><span class="align-middle">Chat</span></a
                ><a class="dropdown-item" href="app-email.html"
                  ><i class="mr-1" data-feather="mail"></i
                  ><span class="align-middle">Email</span></a
                ><a class="dropdown-item" href="app-calendar.html"
                  ><i class="mr-1" data-feather="calendar"></i
                  ><span class="align-middle">Calendar</span></a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Add Details</h4>
                </div>
                <div class="card-body">
                  <ValidationObserver
                    ref="observer"
                    tag="form"
                    v-slot="{ invalid, validate }"
                  >
                    <form
                      class="form form-horizontal"
                      @submit.prevent="validate().then(sendCall)"
                    >
                      <div class="row">
                        <div class="col-12">
                          <div
                            :class="index == 0 ? '' : 'added-field '"
                            v-for="(field, index) in chargesFields"
                            :key="index"
                          >
                            <div class="col-12 text-right mb-2">
                              <button
                                v-if="!index == 0"
                                type="button"
                                class="btn btn-danger mr-1"
                                @click="removeField(index)"
                              >
                                Delete
                              </button>
                            </div>
                            <div class="col-12">
                              <div class="form-group row">
                                <div class="col-sm-3 col-form-label">
                                  <label>Select Charges</label>
                                </div>
                                <div class="col-sm-9">
                                  <ValidationProvider
                                    name="field.chargeId"
                                    ref="field.chargeId"
                                    rules="required"
                                    v-slot="{ errors }"
                                  >
                                    <div class="input-group">
                                      <b-form-select
                                        v-model="field.chargeId"
                                        size="sm"
                                        :class="errors[0] ? 'is-invalid' : ''"
                                        v-validate="'required'"
                                        name="chargeId"
                                        class="mt-1"
                                      >
                                        <b-form-select-option value=""
                                          >Please Select charges
                                        </b-form-select-option>
                                        <b-form-select-option
                                          v-for="(item, index) in chargesData"
                                          :key="index"
                                          :value="item.id"
                                          >{{ item.name }}
                                        </b-form-select-option>
                                      </b-form-select>
                                    </div>
                                    <small
                                      class="block text-red-600 text-xs absolute bottom-0 left-0"
                                      style="color:#EA5455"
                                      >{{ errors[0] }}</small
                                    >
                                  </ValidationProvider>
                                </div>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="form-group row">
                                <div class="col-sm-3 col-form-label">
                                  <label for="name-icon">Charges</label>
                                </div>
                                <div class="col-sm-9">
                                  <ValidationProvider
                                    name="field.charges"
                                    ref="field.charges"
                                    rules="required"
                                    v-slot="{ errors }"
                                  >
                                    <div class="input-group">
                                      <input
                                        type="text"
                                        v-model="field.charges"
                                        id="name-icon"
                                        class="form-control"
                                        :class="errors[0] ? 'is-invalid' : ''"
                                        name="field.charges"
                                        placeholder="Charges"
                                        v-validate="'required'"
                                      />
                                    </div>
                                    <small
                                      class="block text-red-600 text-xs absolute bottom-0 left-0"
                                      style="color:#EA5455"
                                      >{{ errors[0] }}</small
                                    >
                                  </ValidationProvider>
                                </div>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="form-group row">
                                <div class="col-sm-3 col-form-label">
                                  <label>Select Charges Type</label>
                                </div>
                                <div class="col-sm-9">
                                  <ValidationProvider
                                    name="field.chargeType"
                                    ref="field.chargeType"
                                    rules="required"
                                    v-slot="{ errors }"
                                  >
                                    <div class="input-group">
                                      <b-form-select
                                        v-model="field.chargeType"
                                        size="sm"
                                        :class="errors[0] ? 'is-invalid' : ''"
                                        v-validate="'required'"
                                        name="field.chargeType"
                                        class="mt-1"
                                      >
                                        <b-form-select-option value=""
                                          >Please Select charges
                                        </b-form-select-option>
                                        <b-form-select-option
                                          v-for="(item,
                                          index) in chargeTypeOption"
                                          :key="index"
                                          :value="item.value"
                                          >{{ item.value }}
                                        </b-form-select-option>
                                      </b-form-select>
                                      <small
                                        v-show="errorBag.has('chargeType')"
                                        class="invalid-feedback"
                                        >{{
                                          "*" + errorBag.first("chargeType")
                                        }}</small
                                      >
                                    </div>
                                    <small
                                      class="block text-red-600 text-xs absolute bottom-0 left-0"
                                      style="color:#EA5455"
                                      >{{ errors[0] }}</small
                                    >
                                  </ValidationProvider>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--<div class="col-12">
                            <div class="form-group row">
                              <div class="col-sm-3">
                                <label for="rate-icon">Add More Charges </label>
                              </div>
                              <div class="col-sm-9">
                                <input
                                  class="custom-checkbox"
                                  type="checkbox"
                                  v-model="chargesCheckBox"
                                  name="chargesCheckBox"
                                  @change="
                                    ChangewithdrawalCheckBox(chargesCheckBox)
                                  "
                                />
                              </div>
                            </div>
                          </div>-->
                          <div class="col-12">
                            <div class="col-sm-6 offset-sm-3 mb-2">
                              <button
                                type="button"
                                class="btn btn-success mt-2 mr-1"
                                @click="addMoreField"
                              >
                                <i class="fa fa-plus"></i> Add Fields
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="col-sm-9 offset-sm-3 text-right d-flex">
                            <button
                              type="submit"
                              class="btn btn-primary mr-1 d-flex"
                              :disabled="loading"
                            >
                              <Loader :loading="loading" :size="size"></Loader>
                              Submit
                            </button>
                            <button
                              type="button"
                              class="btn btn-gradient-secondary"
                              @click="
                                $router.push({ name: 'privilege-role-add' })
                              "
                            >
                              Back
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </ValidationObserver>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import { CommandIcon } from "vue-feather-icons";
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
  components: {
    CommandIcon,
    ValidationObserver,
    ValidationProvider
  },
  mounted() {
    setTimeout(() => {
    //  this.getChargesData();
    }, 1000);
    let chargesData = this.$store.getters.getByKey("privilegeRoleUpdate");
    this.privilegeId = chargesData.row.id;
  },
  data() {
    return {
      privilegeId: "",
      name: "",
      chargeId: "",
      charges: "",
      chargeType: "",
      chargeTypeOption: [
        {
          id: 0,
          value: "percent"
        },
        { id: 1, value: "fix" }
      ],
      chargesData: [],
      chargesCheckBox: "",
      chargesFields: [
        {
          chargeId: "",
          charges: "",
          chargeType: ""
        }
      ],
      loading: false,
      size: "10px"
    };
  },
  created() {
    this.makeRequest("post", "v1/get-charges", { flag: "active" }).then(
      response => {
        if (!response.error) {
          this.chargesData = response.response.data.data;
        }
      }
    );
  },
  computed: {},
  methods: {
    getChargesData() {
      this.makeRequest("post", "v1/get-charges", { flag: "active" }).then(
        response => {
          if (!response.error) {
            this.chargesData = response.response.data.data;
          }
        }
      );
    },
    ChangewithdrawalCheckBox() {
      if (this.chargesFields.length > 0) {
        this.chargesFields = [];
      }
    },
    addMoreField() {
      let params = {
        chargeId: "",
        charges: "",
        chargeType: ""
      };
      this.chargesFields.push(params);
    },
    removeField(index) {
      this.chargesFields.splice(index, 1);
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          let data = new FormData();
          data.append("application", "android");
          data.append("applicationVersion", "1.33");
          data.append("deviceId", "XXXXXXXXXXXXXXXXXXXXXXXX");
          data.append("deviceDetail", "android s4 etc");
          data.append("latitude", "");
          data.append("longitude", "");

          let chargesData = [];
          this.chargesFields.map(item => {
            if (item.chargeType == "fix") {
              chargesData.push({
                chargeId: item.chargeId.toString(),
                charges: item.charges * 100,
                chargeType: item.chargeType
              });
            } else {
              chargesData.push({
                chargeId: item.chargeId.toString(),
                charges: item.charges,
                chargeType: item.chargeType
              });
            }
          });
          data.append("charges", JSON.stringify({ charges: chargesData }));
          data.append("privilegeId", this.privilegeId);
          this.makeRequest("post", "v1/manage-privilege-charge", data).then(
            callResponse => {
              if (!callResponse.error) {
                let code = callResponse.response.data.code;
                if (code == 200) {
                  this.$router.push({
                    name: "privilege-role-add",
                    params: { add: true }
                  });
                  this.loading = false;
                  if (callResponse.response.data.data) {
                    //  let responseData = callResponse.response.data.data;
                    this.$router.push({
                      name: "privilege-role-add",
                      params: { add: true }
                    });
                  }
                } else if (code == 400) {
                  this.loading = false;
                }
              }
            }
          );
        }
      });
    }
  }
};
</script>

